import { AxiosError } from 'axios';
import { createSelector } from 'reselect';
import { IReasonCodes } from './types';

export const initialSelectors = {
  selectIndexedReasonCodes: () => ({}),
  selectReasonCode: () => null,
};

export const selectLoadedState = (state: { loaded: boolean }) => state.loaded;
export const selectReasonCodes = (state: { reasonCodes: IReasonCodes[] }) => state.reasonCodes;
export const selectSyncError = (state: { error: AxiosError | null }) => state.error;
export const selectSyncState = (state: { syncing: boolean }) => state.syncing;

export const selectIndexedReasonCodes = createSelector(selectReasonCodes, (reasonCodes) =>
  reasonCodes.reduce((indexed: { [x: string]: any }, reasonCodes: IReasonCodes) => {
    if (reasonCodes.groupId) {
      indexed[reasonCodes.groupId] = reasonCodes;
    }
    return indexed;
  }, {})
);
export const selectReasonCode = createSelector(
  [selectIndexedReasonCodes, (_: any, id: any) => id],
  (indexedReasonCodes, id) => indexedReasonCodes[id]
);
